import { render, staticRenderFns } from "./CopyProduct.vue?vue&type=template&id=d292f7b8&scoped=true"
import script from "./CopyProduct.vue?vue&type=script&lang=js"
export * from "./CopyProduct.vue?vue&type=script&lang=js"
import style0 from "./CopyProduct.vue?vue&type=style&index=0&id=d292f7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d292f7b8",
  null
  
)

export default component.exports